module.exports =  Marionette.ItemView.extend( {
	template: '#tmpl-kitbuilder-panel-revisions-revision-item',

	className: 'kitbuilder-revision-item',

	ui: {
		detailsArea: '.kitbuilder-revision-item__details',
		deleteButton: '.kitbuilder-revision-item__tools-delete'
	},

	triggers: {
		'click @ui.detailsArea': 'detailsArea:click',
		'click @ui.deleteButton': 'delete:click'
	}
} );
